import { useFormContext } from 'react-hook-form';
import { realisation as rules } from 'further-ui/validations';
import { realisations } from 'further-ui/domain';

const useSyncInvestorsWithholdingTax = () => {
  const { getValues, setValue } =
    useFormContext<rules.CreateRealisationFormValues>();

  const setInvestorWithholdingTaxList = () => {
    const holdingClassRealisations = getValues('holdingClassRealisation');

    const result = realisations.getUniqueInvestorsWithUnitsRealised({
      holdingClassRealisations,
    });

    if (result) {
      setValue(
        'investorWithholdingTaxList',
        result.map((investor) => ({
          investorName: investor.investorLabel,
          commitmentId: investor.commitmentId,
          totalCommitmentLcy: investor.commitment.totalCommitmentLcy,
          withholdingTaxExempt: false,
        })),
      );
    }
  };

  return { setInvestorWithholdingTaxList };
};

export default useSyncInvestorsWithholdingTax;
